/* tslint:disable */
import {
  CostGuide
} from '../index';

declare var Object: any;
export interface CategoryInterface {
  "_id"?: string;
  "_name": string;
  "_seo_id": string;
  "_profession_singular": string;
  "_profession_plural": string;
  "group"?: number;
  costGuides?: CostGuide[];
}

export class Category implements CategoryInterface {
  "_id": string;
  "_name": string;
  "_seo_id": string;
  "_profession_singular": string;
  "_profession_plural": string;
  "group": number;
  costGuides: CostGuide[];
  constructor(data?: CategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Category`.
   */
  public static getModelName() {
    return "Category";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Category for dynamic purposes.
  **/
  public static factory(data: CategoryInterface): Category{
    return new Category(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Category',
      plural: 'categories',
      properties: {
        "_id": {
          name: '_id',
          type: 'string'
        },
        "_name": {
          name: '_name',
          type: 'string'
        },
        "_seo_id": {
          name: '_seo_id',
          type: 'string'
        },
        "_profession_singular": {
          name: '_profession_singular',
          type: 'string'
        },
        "_profession_plural": {
          name: '_profession_plural',
          type: 'string'
        },
        "group": {
          name: 'group',
          type: 'number'
        },
      },
      relations: {
        costGuides: {
          name: 'costGuides',
          type: 'CostGuide[]',
          model: 'CostGuide'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Category.ts